export default [
    {
        path: 'relatorio-quantitativo-consulta-solicitada',
        component: () => import(
            /* webpackChunkName: 'ambulatorio-relatorio-quantitativo-consulta-solicitada' */
            '@/views/ambulatorio/relatorio-quantitativo-consulta-solicitada/Index'
        ),
        redirect: 'relatorio-quantitativo-consulta-solicitada/index',
        children: [
            {
                name: 'ambulatorio-relatorio-quantitativo-consulta-solicitada-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'ambulatorio-relatorio-quantitativo-consulta-solicitada' */
                    '@/views/ambulatorio/relatorio-quantitativo-consulta-solicitada/List.vue'
                ),
            },
        ],
    },
]